import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import './Faqs.css';
import { baseurl } from '../../api';
import { isRequired } from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "faq"

const FAQs = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]);
  const [popupError, setPopupError] = useState('');
  const [category,setCategories] = useState([]);
  const navigate = useNavigate();
  const sortOptions = ['A-Z', 'Z-A', 'Newst','Oldest'];
  const filterOptions = ['Default', 'Archived','Unarchived'];
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["FAQ's"] || 0;
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);

  const fetchFaq = async (id = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}faq/faq/?id=${id}`);
        if (response && response.data) {
          setSelectedItem(response.data.data); 
          setIsEditPopupOpen(true); 
        } else {
          console.error("No data found for the selected FAQ.");
        }
      } else {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
  
        const response = await authenticatedAxios.get(`${baseurl}faq/faq`, { params });
        if (response.data.response_code === 1) {
          setItems(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching FAQs:', error);
      }
    }
  };
  

  useEffect(() => {
    
    const fetchCategories = async () => {
      try {
          const response = await authenticatedAxios.get(`${baseurl}faq/category/active/`);
          const result = response.data;
          
          if (result.response_code === 1 && Array.isArray(result.data)) {
              setCategories(result.data.map(category => ({ label: category.name, value: category.id })));
          } else {
              console.error('Fetched categories are not valid:', result);
              setCategories([]);
          }
      } catch (error) {
          console.error('Error fetching categories:', error);
          setCategories([]);
      }
    };

    fetchFaq();
    fetchCategories();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]); 


  useEffect(() => {
    fetchFaq();
  }, [refreshKey]);

  const handleAddFAQ = async (formValues) => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}faq/faq/`, formValues);
  
      if (response.data.response_code === 1) {
        await fetchFaq();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to add FAQ. Please try again.');
    }
  };
  
  const handleEditFAQ = async (formValues) => {
    try {
      const response = await authenticatedAxios.put(
        `${baseurl}faq/faq/?id=${selectedItem.id}`,
        formValues
      );
  
      if (response.data.response_code === 1) {
        await fetchFaq();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to update FAQ. Please try again.');
    }
  };
  

  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}faq/faq/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchFaq();
        resetCheckboxState();
        closePopups();
      } 
    } catch (error) {
     
    }
  };

  const handleArchive = async () => {
    try {
        const response = await authenticatedAxios.get(`${baseurl}faq/faq/archive/?id=${selectedItem.id}`);
        if (response.status >= 200 && response.status < 300) {
            await fetchFaq();  
            closePopups();      
        } 
    } catch (error) {    
    }
  };

  const handleDeleteFaq = async () => {
    try {
        const response = await authenticatedAxios.delete(
            `${baseurl}faq/faq/?id=${selectedItem.id}`
        );

        if (response.status >= 200 && response.status < 300) {
            await fetchFaq();
            closePopups(); 
        } else {
            console.error('Failed to delete category:', response.data);
        }
    } catch (error) {
        console.error('Error deleting category:', error);
    }
  };

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };
  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };


  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };
  
  const handleEditClick = (item) => {
    setSelectedItem(item)
    setIsEditPopupOpen(true)
  };

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };

  const handleNewClick = () => {
    setSelectedItem(null);
    setIsNewPopupOpen(true);
  };
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsDeletePopupOpen(false);
    setSelectedItem(null);
    setPopupError('');
  };
  const addPopupFields = [
    { label: 'Category', 'name':'category',type: 'large-select', options: category, defaultValue: '',validators:[isRequired] },
    { label: 'Question', 'name':'question',type: 'text', defaultValue: '',validators:[isRequired] },
    { label: 'Answer', 'name':'answer',type: 'text', defaultValue: '',validators:[isRequired] }
  ];

  const deletePopupFields = [
    { label: 'Are you sure you want to archive this record? Once archived, the data will be inaccessible and may impact ongoing customer interactions.', type: 'text' },
  ];
  
  const editPopupFields = [
    { label: 'Category', name: 'category', type: 'large-select',options: category, defaultValue: selectedItem?.category.id || '',},
    { label: 'Question',name: 'question', type: 'text', defaultValue: selectedItem?.question || '', onChange: () => {} },
    { label: 'Answer',name: 'answer', type: 'text', defaultValue: selectedItem?.answer || '', onChange: () => {} },
  ];

  const handleExportComplete = () => {
    resetCheckboxState();
  };

  return (
    <div className='whole-container'>  
      <div className='top-heading'>
        <PageHeader pageName=" FAQ /" nestedpageName="FAQs"  linkTo="" />
        <div className='export-container'>
        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
          <ExportLabel
            exportUrl={`${baseurl}faq/faq/export/`}
            selectedIds={selectedItems}
            onExportComplete={handleExportComplete}
          />
        </div>
      </div>     
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>FAQ's</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox placeholder="Search FAQ" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect}  defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                <input
                  className="table-selectbox table-parent-selectbox"
                  type="checkbox"
                  checked={isParentSelected}
                  onChange={handleParentCheckboxChange}
                />Question
              </th>
              <th>Answer</th>
              <th className='w-10'>category</th>
              <th></th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
          {items.length > 0 ? (
            items.map((faq) => (
              <tr key={faq.id} className={faq.is_archived ? 'archived-item' : ''}>
                <td className='d-flex'>
                  <div>
                  <input
                    className="table-selectbox table-child-selectbox db"
                    type="checkbox"
                    checked={selectedItems.includes(faq.id)}
                    onChange={() => handleChildCheckboxChange(faq.id)}
                  />
                  </div>
                  <div>
                  {faq.question}
                  </div>
                   
                  
                </td>
                <td style={{width:'40%'}} className='pr-30'>{faq.answer}</td>
                <td className='w-10'>{faq.category.name}</td>
                <td className="actions common-action">
                    <EditIcon onClick={() => handleEditClick(faq)} /> 
                    <ArchiveIcon onClick={() => handleArchiveClick(faq)} isArchived={faq.is_archived}/>
                    <DeleteIcon onClick={() => handleDeleteClick(faq)} />
                </td>   
              </tr>
            ))
            ):(
              <tr>
                <td colSpan="3">No Faqs Available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      <EditPopup 
        isOpen={isEditPopupOpen}
        title="FAQ"
        fields={editPopupFields}
        onSave={handleEditFAQ}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />


      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.question }
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      <DeletePopup 
        isOpen={isDeletePopupOpen}
        title="Delete"
        fields={deletePopupFields}
        onSave={handleDeleteFaq}
        onClose={closePopups}
      />
      <AddPopup 
        isOpen={isNewPopupOpen}
        title="ADD FAQ"
        buttonName='Add FAQ'
        fields={addPopupFields}
        onSave={handleAddFAQ}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />

    </div>
  );
};

export default FAQs;
